export default "__VITE_ASSET__ykrFyaqd__"